export const CASE_ACTIONS = {
    CASE_SEARCH: 'CASE_SEARCH',
    CASE_SEARCH_SUCCESS: 'CASE_SEARCH_SUCCESS',
    CASE_SEARCH_ERROR: 'CASE_SEARCH_ERROR',

    CASE_UPSERT: 'CASE_UPSERT',
    CASE_UPSERT_SUCCESS: 'CASE_UPSERT_SUCCESS',
    CASE_UPSERT_ERROR: 'CASE_UPSERT_ERROR',

    CASE_EDIT: 'CASE_EDIT',

    CO_APPLICANT_REMOVE: 'CO_APPLICANT_REMOVE',

    CASE_RESET: 'CASE_RESET',
};

export const caseResetAction = () => ({
    type: CASE_ACTIONS.CASE_RESET,
});

export const caseSearchAction = (payload) => ({
    type: CASE_ACTIONS.CASE_SEARCH,
    ...payload,
});

export const caseEditAction = (payload) => ({
    type: CASE_ACTIONS.CASE_EDIT,
    ...payload,
});

export const caseUpsertAction = (payload) => ({
    type: CASE_ACTIONS.CASE_UPSERT,
    ...payload,
});

export const invoiceUpsertAction = (payload) => ({
    type: CASE_ACTIONS.CASE_UPSERT,
    ...payload,
});
export const receiptUpsertAction = (payload) => ({
    type: CASE_ACTIONS.CASE_UPSERT,
    ...payload,
});
export const paymentUpsertAction = (payload) => ({
    type: CASE_ACTIONS.CASE_UPSERT,
    ...payload,
});
export const CoApplicantRemoveAction = (payload) => ({
    type: CASE_ACTIONS.CO_APPLICANT_REMOVE,
    ...payload,
});

export default {
    CASE_ACTIONS,
    caseSearchAction,
    caseUpsertAction,
    caseEditAction,
    invoiceUpsertAction,
    receiptUpsertAction,
    paymentUpsertAction,
    caseResetAction,
    CoApplicantRemoveAction,
};
